import React from 'react';
import '../css/form.css';
import '../css/alerts.css';
import { Form, Button, Container, Modal, Spinner, Row, Col} from "react-bootstrap";
import EncabezadoCliente from '../components/header';
import axios from 'axios';
import Contacto from '../components/contacto';
import Nivel1 from '../components/nivel1';
import Nivel2 from '../components/nivel2';
import Nivel3 from '../components/nivel3';

axios.defaults.headers.post['authorizationToken'] = '&S396b<eg5Zn(HiLe)BBNtc&';
const baseUrl = 'https://b316wmuwh1.execute-api.us-east-1.amazonaws.com/default/res_json_gestiones';

class Tipificaciones extends React.Component{

    constructor(props) {
        
        const { match: { params } } = props;
        console.log(params)

        super(props);
        this.state = {
            id_gestion: params.idGestion,
            id_contacto: params.idContacto,
            id_campana: params.idCampana,
            id_contacto_genesys: params.idContactoGenesys,
            id_ejecutivo: params.idEjecutivo,
            fono: params.fono,
            cola: params.cola,
            formValid: true,
            contador: 0,
        };
        
        //Se definen las funciones llamadas por el formulario
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMostrarModal = this.handleMostrarModal.bind(this);
        this.handleEnviodatos = this.handleEnviodatos.bind(this);
        this.handleInputChangeObs = this.handleInputChangeObs.bind(this);
        //this.dataValidation = this.dataValidation.bind(this);
        
    }

    //con este metodo se guarda el dato de ingresado con la variable ingresada en los props
    async handleInputChangeObs(event){
        const target = event.target;
        const valor = target.value;
        const nombre = target.name;
        this.setState({
            [nombre]: valor.replace(/[^\w\s]/gi,'')
        })
    }

    //con este metodo se guarda el dato de ingresado con la variable ingresada en los props
    async handleInputChange(event){
        const target = event.target;
        const valor = target.value;
        const nombre = target.name;
        this.setState({
            [nombre]: valor
        })
    }

    //metodo para la accion de la presion del btn submit 
    async handleSubmit(e){
        e.preventDefault();
        if(this.dataValidation === false){
            this.setState({ formValid: false})
            return (alert('Ingresa campos requeridos!'))
        }else{
            console.log('obtengo metodo de los datos')
            this.handleMostrarModal()
        }   
    }

    //abre el modal para confirmar el envio de datos
    async handleMostrarModal(){
        console.log('confirma los datos')
        this.setState({show:true})
    }

    //confirma el envio de datos para continuar con el envio de datos
    async handleConfirm() {
        this.setState({show:false, confirm:true})
        document.getElementById('btn_form').hidden = true;
        document.getElementById('cargando').hidden = false;
        this.handleEnviodatos()//metodo de envio de datos
    }

    //cierra el modal para confirmar los datos
    async handleClose(){
        this.setState({
            show: false,
        })
    }

    //metodo para el envio de datos que posee el formulario a la base de datos
    async handleEnviodatos(){
        //en esta serccion se ingresan los datos a enviar por el formulario
        const body = JSON.stringify({
            id_gestion: this.state.id_gestion,
            id_contacto: this.state.id_contacto,
            id_campana: this.state.id_campana,
            id_contacto_genesys: this.state.id_contacto_genesys,
            id_ejecutivo: this.state.id_ejecutivo,
            fono: this.state.fono,
            cola: this.state.cola,
            contacto: this.state.contacto,
            nivel1: this.state.nivel1,
            nivel2: this.state.nivel2,
            nivel3: this.state.nivel3,
            Obserbacion: this.state.Obserbacion,
        })
        console.log(body)
        //con este metodo le pegamos un post a lambda para el envio de datos
        await axios.post(baseUrl,body)
        .then(response => {
            if(response.status === 200) {    
                document.getElementById('btn_form').hidden = false;
                document.getElementById('cargando').hidden = true;
                document.getElementById('ok').hidden = false;
            }
            else{
                document.getElementById('error').hidden = true;
            }
            console.log('el metodo responde: '+response.data.state);
            console.log('Envio a parent');
            //this.limpiarForm(); metodo para limpiar Formulario esto se debe crear

            if(this.state.nivel3 === 'ARGUMENTADO SI'){
                window.location.href='/formulario/users/'+this.state.id_ejecutivo+'/idcontacto/'+this.state.id_contacto+'/idinteraccion/'+this.state.id_gestion+'/idcampana/'
                +this.state.id_campana+'/idcontactogenesys/'+this.state.id_contacto_genesys+'/fono/'+this.state.fono+'/cola/'+this.state.cola
            }
            else{    
                window.parent.postMessage({gestion_finished:true}, "*")
                document.getElementById('btn_form').disabled = true;
            }
            
        })
        .catch(response => {
            console.log(response + ' error POST envio datos')
        })
    }

    render(){
        return(
            <Container>
                <div>
                    <EncabezadoCliente data={this.state.id_contacto}></EncabezadoCliente>
                </div>
                <hr/>
                <div className="row align-items-end ">
                    <div className="col align-self-center h-h-100 p-5 bg-light border rounded-3">
                        <Form onSubmit={this.handleSubmit}>
                            <Row className="mb-3">    
                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                    <Form.Label>Contactado</Form.Label>
                                    <Form.Control size='sm' as="select" name='contacto' value={this.state.contacto} onChange={this.handleInputChange} required>
                                        <option value=''>Seleccionar</option>
                                        <Contacto value={this.state.contacto}/>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom02">
                                    <Form.Label>Nivel 1</Form.Label>
                                    <Form.Control size='sm' as="select" name='nivel1' value={this.state.nivel1} onChange={this.handleInputChange} required> 
                                        <option value=''>Seleccionar</option>
                                        <Nivel1 data={this.state.contacto}></Nivel1>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="validationCustom03">
                                    <Form.Label>Nivel 2</Form.Label>
                                    <Form.Control size='sm' as="select" name='nivel2' value={this.state.nivel2} onChange={this.handleInputChange} required>
                                        <option value=''>Seleccionar</option>
                                        <Nivel2 data={this.state.nivel1}></Nivel2>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom04">
                                    <Form.Label>Nivel 3</Form.Label>
                                    <Form.Control size='sm' as="select" name='nivel3' value={this.state.nivel3} onChange={this.handleInputChange} required>
                                        <option value=''>Seleccionar</option>
                                        <Nivel3 data={this.state.nivel2}></Nivel3>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="validationCustom05">
                                    <Form.Label>Observacion</Form.Label>
                                    <Form.Control size='sm' as="textarea" name='Observacion' value={this.state.Observacion} onChange={this.handleInputChangeObs}>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Button variant="primary" type="submit" id='btn_form'>Continuar</Button>
                            <Spinner animation="border" id='cargando' variant="primary" hidden/>
                        </Form>
                        <div className="success-msg" id='ok' hidden><i className="fa fa-check"></i> Tipificacion exitosa.</div>
                        <div className="error-msg" id='error' hidden><i className="fa fa-times-circle"></i> Error al ingresar la Tipificacion.</div>
                    </div>
                </div>
                <Modal
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                <Modal.Header closeButton>
                    {/* <Modal.Title>Modal title</Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>
                    Desea guardar los cambios del formulario?
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="danger" onClick={this.handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.handleConfirm}>Confirmar</Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        )
    }

}

export default Tipificaciones